import {CameraIcon, UserIcon} from '@heroicons/react/24/outline';
import {Skeleton} from '../../components/skeletons/Skeleton';

interface ProfileStatsProps {
  creationYear?: number | string;
  tripCount: number;
  isLoadingProfile: boolean;
  isLoadingTrips: boolean;
}

/**
 * Profile statistics badges (member since, trip count).
 */
export const ProfileStats = ({
  creationYear,
  tripCount,
  isLoadingProfile,
  isLoadingTrips,
}: ProfileStatsProps) => {
  return (
    <div className="mt-1 flex items-center justify-center">
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-4">
        {isLoadingProfile ? (
          <Skeleton className="h-6 w-32" />
        ) : (
          <p
            style={{ color: '#023759' }}
            className="inline-flex items-center px-2 py-1 text-xs"
          >
            <UserIcon className="w-4 h-4 mr-1" />
            Since: {creationYear ?? ''}
          </p>
        )}
        {isLoadingTrips ? (
          <Skeleton className="h-6 w-24" />
        ) : (
          <p
            style={{ color: '#023759' }}
            className="inline-flex items-center px-2 py-1 text-xs"
          >
            <CameraIcon className="w-4 h-4 mr-1" />
            Trips: {tripCount}
          </p>
        )}
      </div>
    </div>
  );
};
